import OfertaDelete from './OfertaDelete.vue'

export default OfertaDelete

